// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ngFJ","placeholdersHeader":"styles_placeholdersHeader__2tM9x","editorStyle":"styles_editorStyle__r0c7R","placeholdersBox":"styles_placeholdersBox__2_QWf"};